export const SHIP_FREE_MODAL_PATH = 'ship_free_modal';

export const MAX_QUANTITY_COUNT = 15;
